<template>
  <!-- 订单详情物流列表 -->
  <div
    v-if="getTrackingDataBySubOrderSn && getTrackingDataBySubOrderSn !== null"
    class="log_con"
  >
    <div class="font12 font_weight400 colo038 line_height_17 text_left">
      物流公司：<span class="colo087">{{
        getTrackingDataBySubOrderSn.companyName
      }}</span>
    </div>
    <div
      class="order_id font12 font_weight400 colo038 line_height_20 text_left"
    >
      <div>
        物流单号：<span class="colo087">{{
          getTrackingDataBySubOrderSn.trackingNo
        }}</span>
      </div>
      <div
        v-clipboard:copy="getTrackingDataBySubOrderSn.trackingNo"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        class="font_weight400 colo087 copy_id"
      >
        复制
      </div>
    </div>
    <div
      v-if="
        getTrackingDataBySubOrderSn.trackingDataList &&
          getTrackingDataBySubOrderSn.trackingDataList.length
      "
      class="list"
    >
      <div
        v-for="(i, index) in getTrackingDataBySubOrderSn.trackingDataList"
        :key="index"
        class="list_item text_left"
      >
        <div
          v-if="
            index !== getTrackingDataBySubOrderSn.trackingDataList.length - 1
          "
          :class="{ left_line_bg: index !== 0 }"
          class="left_line"
        ></div>
        <img
          v-if="
            index === 0 ||
              index ===
                getTrackingDataBySubOrderSn.trackingDataList.length - 1 ||
              index === getTrackingDataBySubOrderSn.trackingDataList.length - 2
          "
          :src="
            index === 0
              ? indexImg
              : index ===
                getTrackingDataBySubOrderSn.trackingDataList.length - 2
              ? buyedImg
              : payedImg
          "
          alt=""
          class="list_icon"
        />
        <div v-else class="round_step"></div>
        <div class="item_det">
          <!-- <div class="font14 font_weight500 colo087">派送中{{ index }}</div> -->
          <div
            v-html="judge(i.context, i.phone)"
            class="font12 font_weight400 colo087"
          ></div>
          <div v-if="i.status !== 1" class="11 font12 colo055">
            {{ i.time }}
          </div>
          <div v-if="i.status === 1" class="11 font12 colo055">
            {{ i.time | dateFormatterJava("YYYY-MM-DD HH:mm:ss") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      payedImg: require("@/assets/order/payed@2x.png"),
      buyedImg: require("@/assets/order/buyed@2x.png"),
      indexImg: require("@/assets/login/select@2x.png")
    };
  },
  computed: {
    getTrackingDataBySubOrderSn() {
      let data = {};
      if (this.$route.query.purPage == "milkplan") {
        // 配送计划
        data = this.$store.getters.getTrackingDataByTrackingNo;
      } else {
        data = this.$store.getters.getTrackingDataBySubOrderSn;
      }
      return data;
    }
  },
  // mounted() {
  //   console.log(/abc/gi.test("123#abrrrr"));
  // },
  methods: {
    onCopy() {
      this.$toast("运单号已复制到剪贴板！");
    },
    onError() {
      this.$toast("复制失败，请重试！");
    },
    judge(str, cond) {
      //str输入的字符串，cond要匹配的字符
      if (!cond) {
        return str;
      }
      var reg = new RegExp(cond, "g");
      return str.replace(reg, `<a href="tel:${cond}">${cond}</a>`);
    }
  }
};
</script>

<style lang="less" scoped>
.log_con {
  background: #fff;
  margin-top: 12px;
  border-radius: 8px;
  padding: 16px 12px 16px 16px;
  .order_id {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-top: 4px;
    .copy_id {
      padding: 0 8px;
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.38);
    }
  }
  .list {
    margin-top: 18px;
    margin-left: 20px;
    .list_item {
      display: flex;
      font-size: 0;
      position: relative;
      .list_icon {
        width: 24px;
        height: 24px;
        margin-right: 12px;
        position: absolute;
        top: 0px;
        left: -12px;
      }
      .item_det {
        width: 270px;
        padding: 0 0 24px 23px;
      }
      .round_step {
        width: 4px;
        height: 4px;
        background: #ddd;
        border: 2px solid #fff;
        border-radius: 50%;
        // margin-right: 10px;
        position: absolute;
        top: 4px;
        left: -2px;
      }
      .left_line {
        width: 1px;
        background: linear-gradient(
          180deg,
          rgba(255, 12, 19, 1) 0%,
          rgba(221, 221, 221, 1) 100%
        );
        margin: 15px 0 0 0;
      }
      .left_line_bg {
        background: rgba(221, 221, 221, 1) !important;
      }
    }
  }
}
</style>
